// libraries
import clsx from 'clsx'

// components
import Link from '/react4xp/components/Link'

// icons
import { ChevronRight } from '/react4xp/components/Icons/Ux'

// types
interface BreadcrumbsProps {
    className?: string
    standalone?: boolean
    items: {
        label: string
        url?: string
    }[]
}

// css
import './index.scss'

export default function Breadcrumbs({
    className,
    standalone,
    items
}: BreadcrumbsProps) {
    // NOTE: breadcrumb JSON-LD is emitted server-side (lib/modules/seo) — see
    // NLA-240. Do not re-add structured data here.
    return items.length > 0 ? (
        <nav
            className={clsx(
                'breadcrumbs',
                className,
                standalone && 'container breadcrumbs--standalone'
            )}
            aria-label='Breadcrumbs'
        >
            <ul>
                {items.map((item, i) => (
                    <li key={i} className='breadcrumbs__item'>
                        {item.url ? (
                            <Link
                                href={item.url}
                                label={{
                                    underline: item.label
                                }}
                            />
                        ) : (
                            <span
                                className='breadcrumbs__current'
                                aria-current='page'
                            >
                                {item.label}
                            </span>
                        )}

                        <span className='breadcrumbs__separator' aria-hidden='true'>
                            <ChevronRight />
                        </span>

                    </li>
                ))}
            </ul>
        </nav>
    ) : null
}